import { BaseModel } from './base';

export class ContractInfo extends BaseModel {
  contractTitle: string;
  contractDescription: string;
  startDate: string;
  endDate: string;
  contractRefNo: string;
  contractStatusId: string;
  contractTypeId: string;
  contractMode: string;
  contractorsId: string;
  contractAmount: number;
  departmentId: string;
  departmentName: string;
  contractStatusName: string;
  contractName: string;
  contractorName: string;
  expirationDays: number;
  amountInvoiced: number;
  contractBalance: number;
  dateCreated: Date;
  dateModified: Date;
  subscriberId: string;
  siteId: string;
  id: string;
  durationType: string;
  currencyName: string;
  currencyId: string;
  contractorRepsName: string;
}
